<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import type { FrequentlyAskedQuestionsProps } from "./FrequentlyAskedQuestionsProps.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import Branches from "../components/Branches.svelte";
	import ProductCard from "../components/Product/ProductCard.svelte";
	import FrequentlyAskedQuestions from "../components/FrequentlyAskedQuestions.svelte";

	type $$Props = FrequentlyAskedQuestionsProps;

	const { frequentlyAskedQuestions, maxProductsPerCategory, plannedIceCreams, recommendedProducts } =
		$$restProps as $$Props;

	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

<Layout>
	<div class="container">
		<div class="mt-6 flex flex-col items-center gap-8 md:mt-10">
			<span class="text-center text-base font-semibold uppercase leading-7 tracking-[0.9375rem] md:text-md">
				Máte otázku?
			</span>
			<h1 class="m-0 p-0 text-center text-[1.8rem] font-semibold leading-10 md:text-2xl lg:mt-0 lg:leading-[4.25rem]">
				{nbspify("Odpovědi na časté dotazy")}
			</h1>
		</div>
		<FrequentlyAskedQuestions questionAndAnswers={frequentlyAskedQuestions} />
	</div>

	<div class="container">
		<section class="container">
			{#if recommendedProducts.length > 0}
				<h2 class="text-center text-base font-semibold uppercase leading-7 tracking-[0.9375rem] md:text-md">
					Doporučujeme
				</h2>
				<div class="product-card-wrapper mt-6 lg:mt-8">
					{#each recommendedProducts as product (product.id)}
						<ProductCard {product} {maxProductsPerCategory} asCrossSale={true} />
					{/each}
				</div>
			{/if}
		</section>

		<section>
			<Branches {plannedIceCreams} />
		</section>
		<div class="flex w-full justify-center">
			<span class="max-w-[35rem] text-center text-lg font-semibold md:text-2xl md:leading-[4.25rem]"
				>Těšíme se<br />na vaši návštěvu!</span
			>
		</div>
	</div>
</Layout>
